import { useMemo } from 'react';
import { Country } from '@tiendanube/common/src/enums';
import { useGetCountry } from 'domains/Auth/hooks';
import { PopoverUnpacked } from 'domains/NuvemEnvioCommons/components';
import {
  DefaultSavedSearchesCode,
  SavedSearchInterface,
} from 'domains/Orders/Orders/ordersSlice/savedSearches';

interface SavedSearchPopoverWrapperProps {
  isSelected: boolean;
  savedSearch: SavedSearchInterface;
  children: React.ReactNode;
}

export function SavedSearchPopoverWrapper({
  children,
  isSelected,
  savedSearch,
}: SavedSearchPopoverWrapperProps) {
  const country = useGetCountry();

  const showPopover = useMemo(() => {
    const showUnpackedOrSendPopover =
      country === Country.BR &&
      isSelected &&
      (savedSearch.key === DefaultSavedSearchesCode.READY_TO_PACK ||
        savedSearch.key === DefaultSavedSearchesCode.READY_TO_SEND);

    switch (savedSearch.key) {
      case DefaultSavedSearchesCode.READY_TO_PACK:
        return showUnpackedOrSendPopover;
      case DefaultSavedSearchesCode.READY_TO_SEND:
        return showUnpackedOrSendPopover;
      default:
        return false;
    }
  }, [isSelected, country, savedSearch.key]);

  const Popover = useMemo(() => {
    switch (savedSearch.key) {
      case DefaultSavedSearchesCode.READY_TO_PACK:
      case DefaultSavedSearchesCode.READY_TO_SEND:
        return PopoverUnpacked;
      default:
        return undefined;
    }
  }, [savedSearch.key]);

  // While not selected we avoid rendering the popover
  // to prevent unnecessary data fetching from the popover component logic
  if (!Popover || !showPopover) {
    return <div>{children}</div>;
  }

  return <Popover isSelected={showPopover}>{children}</Popover>;
}
